module.exports = __webpack_public_path__ + "img/pdf.1dfb8f57.png";